import { faClose } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Badge } from 'react-bootstrap';

type OfficeBadgeProps = {
  height?: number;
  officeName: string;
  onClick: (officeId: number) => void;
};

const OfficeBadge = ({ officeName, onClick, height = 42 } : OfficeBadgeProps) => {
  return (
    <Badge
      className="clickable px-3 py-2 d-flex gap-3 align-items-center"
      style={{ height }}
      onClick={onClick}
    >
      <div>
        {officeName}
      </div>
      <FontAwesomeIcon icon={faClose} />
    </Badge>
  );
};

export default OfficeBadge;
